import firebase from 'firebase/app';

//blueprint
import { Position,  Intent, Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({
    className: "prospected-contact",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Finished Prospecting", intent: Intent.SUCCESS, timeout: 1000});
}

export const FinishedProspecting = (id, profile) =>{
    firebase
    .firestore()
    .collection('organizations')
    .doc(profile.company)
    .collection('checkedContacts')
    .doc(id)
    .delete()
    .then(()=>{
        showToast();
    })
}